export default "__VITE_ASSET__eLGu27e2__"